export const PROCESSING_RESULTS = {
  ALL_SUCCEEDED: "ALL_SUCCEEDED",
  SOME_FAILED: "SOME_FAILED",
  ALL_FAILED: "ALL_FAILED",
  APPROVED_SUCCEEDED: "APPROVED_SUCCEEDED",
  REJECTED_SUCCEEDED: "REJECTED_SUCCEEDED",
  CHECK_IN_SUCCEEDED: "CHECK_IN_SUCCEEDED",
  // Per-entry status: the equipment slot was already booked by a concurrent
  // request (RETINA-7688938). Present on entries[], not at command level.
  COLLIDING: "COLLIDING",
};

// Conflict-specific toast copy shown when a booking is rejected because the
// equipment slot was taken by another user at the same time (RETINA-7688938).
export const CONFLICT_MESSAGES = {
  ALL: "This equipment was just booked by someone else for the selected time. Please choose a different time or instrument and try again.",
  SOME: 'Some of your selected equipment/time slot(s) were just booked by someone else. Please check "My bookings" and try a different time for the affected item(s).',
};

export const BOOKING_OPERATIONS = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  CANCEL: "CANCEL",
  END: "END",
  APPROVE: "APPROVE",
  REJECT: "REJECT",
  CHECK_IN: "CHECK_IN",
  DELETE: "DELETE",
};

export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  INFO: "info",
};

export const OPERATION_STATUS = {
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const DEFAULT_MESSAGES = {
  [PROCESSING_RESULTS.ALL_SUCCEEDED]: {
    [BOOKING_OPERATIONS.CREATE]: "Booking confirmed successfully!",
    [BOOKING_OPERATIONS.UPDATE]: "Booking updated successfully!",
    [BOOKING_OPERATIONS.CANCEL]: "Booking has been cancelled successfully!",
    [BOOKING_OPERATIONS.END]: "Booking updated",

    [BOOKING_OPERATIONS.APPROVE]: "Booking has been approved successfully!",
    [BOOKING_OPERATIONS.REJECT]: "Booking has been rejected successfully!",
    //[BOOKING_OPERATIONS.REJECT_END]: "Booking update undone",
    [BOOKING_OPERATIONS.CHECK_IN]: "Check-in completed successfully!",
    [BOOKING_OPERATIONS.DELETE]: "Booking has been deleted successfully!",
    default: "Operation completed successfully!",
  },
  [PROCESSING_RESULTS.SOME_FAILED]: {
    default:
      'There was an issue with your equipment booking timeslots(s). Please check "My bookings" for more information.',
  },
  [PROCESSING_RESULTS.ALL_FAILED]: {
    default: "There were problems with booking, please check detailed statuses.",
  },
  [PROCESSING_RESULTS.APPROVED_SUCCEEDED]: {
    default: "Booking has been approved successfully!",
  },
  [PROCESSING_RESULTS.REJECTED_SUCCEEDED]: {
    default: "Booking has been rejected successfully!",
  },
};

export const createCallbackConfig = ({
  operation = BOOKING_OPERATIONS.UPDATE,
  onSuccess,
  onError,
  customMessages = {},
  skipNotification = false,
  debounceDelay = 2500,
}) => ({
  operation,
  onSuccess,
  onError,
  customMessages,
  skipNotification,
  debounceDelay,
});
